<template>
  <div class="border-end bg-light indicators-box d-flex justify-content-center align-items-center">
    <AVIcon
      v-if="item._destroy"
      icon="trash-can"
      class="cursor-help text-danger"
      v-tooltip="$t('backend.candidacy.components.field_indicators.deleting')"
      :aria-label="$t('backend.candidacy.components.field_indicators.deleting')"
    />
    <div v-else class="vstack justify-content-evenly align-items-center text-dark">
      <AVIcon
        :icon="itemIcon"
        class="cursor-help"
        v-tooltip="humanize(exapndedItem.item_type)"
        :aria-label="humanize(exapndedItem.item_type)"
      />
      <AVIcon
        v-if="exapndedItem.public"
        icon="globe-americas"
        class="cursor-help"
        v-tooltip="$t('backend.candidacy.components.field_indicators.public')"
        :aria-label="$t('backend.candidacy.components.field_indicators.public')"
      />
      <AVIcon
        v-if="exapndedItem.required"
        icon="asterisk"
        class="cursor-help"
        v-tooltip="$t('backend.candidacy.components.field_indicators.required')"
        :aria-label="$t('backend.candidacy.components.field_indicators.required')"
      />
      <AVIcon
        v-if="exapndedItem.localised"
        icon="language"
        class="cursor-help"
        v-tooltip="$t('backend.candidacy.components.field_indicators.translatable')"
        :aria-label="$t('backend.candidacy.components.field_indicators.translatable')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { humanize } from "@/lib/candidacy/form_builder/utils";
import { expandItem } from "@/entrypoints/candidacy/candidate_helpers";
import type { EveryBuildableItem, PropType, ItemType } from "@/types";

export default defineComponent({
  name: "FieldIndicators",
  props: {
    item: {
      type: Object as PropType<EveryBuildableItem>,
      required: true,
    },
    types: {
      type: Array as PropType<ItemType[]>,
      required: true,
    },
  },
  computed: {
    itemIcon() {
      return this.types.find((type: ItemType) => type.item_type === this.item.item_type).icon;
    },
    exapndedItem() {
      return this.expandItem(this.item);
    },
  },
  methods: { humanize, expandItem },
});
</script>

<style scope>
  .indicators-box {
    min-width: 2.5rem;
  }
</style>
